import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

export default function usePositions(rawAddress, chainId) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!rawAddress || chainId !== 4663) {
      setRows([]);
      return;
    }
    let stop = false;
    setLoading(true);
    async function load() {
      try {
        const { data } = await axios.get(`${API}/positions/${rawAddress}`, { timeout: 20000 });
        if (stop) return;
        setRows(data || []);
      } catch (e) {
        // keep empty
      } finally {
        setLoading(false);
      }
    }
    load();
    const id = setInterval(load, 45_000);
    return () => { stop = true; clearInterval(id); };
  }, [rawAddress, chainId]);
  return { rows, loading };
}
